import AxiosClient from "../../../services/axios.services";

class StatusesServices {
  getStatus = (params) =>
    AxiosClient.get(
      "/api/app/carrera_estado/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getStatusByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_estado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveStatus = (data) =>
    AxiosClient.post(
      "/api/app/carrera_estado/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editStatus = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_estado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteStatus = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_estado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new StatusesServices();
